var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('validation-component',{ref:"businessFormRef",attrs:{"validation-condition":_vm.businessCondition}}),_c('div',{staticClass:"margin-top-20"},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"type":"primary"},on:{"click":_vm.onSubmit}},[_vm._v(_vm._s(_vm.$t("message.common.next")))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }